<bringoz-button theme="secondary" class="full-width"
                (onClick)="login()">
  <span>{{'Log In' | translate}}</span>
</bringoz-button>
